module.exports = __webpack_public_path__ + "../resources/images/illustration_drink-287cf6a889b542d1e6b025c276a1c482.svg";